import React from 'react'
import Section from '../../../shared/settings/section'
import PinSettings from './pin-settings'
import PinForm from './pin-form'
import { TESTERS } from '../../../../lib/tester-classnames'

function ProfileSecurity() {
  return (
    <Section title="Profile Security" testerClassName={TESTERS.ACCOUNT.PROFILE_SECURITY}>
      <PinForm />
      <PinSettings />
    </Section>
  )
}

export default ProfileSecurity
